import React from 'react'
import Snackbar from '@material-ui/core/Snackbar'
import { Alert } from '@material-ui/lab'

function AlertWrapper(props) {
    const { description, handleClose, type, visible } = props

    return (
        <Snackbar open={visible} autoHideDuration={3000} onClose={handleClose}>
            <Alert onClose={handleClose} severity={type}>
                {description}
            </Alert>
        </Snackbar>
    )
}

export default AlertWrapper
